import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {},
  rootTitle: {
    marginLeft: theme.spacing(0.5),
  },
  drawer: {
    width: 320,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "fixed",
  },
  drawerOpen: {
    width: 320,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#FFFFFF!important",
    padding: theme.spacing(1),
    zIndex: 100,
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    backgroundColor: "#FFFFFF!important",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    marginTop: "66px",
    // necessary for content to be below app bar
    justifyContent: "flex-start",
  },
  icon: {
    color: "white",
  },
  nested: {
    paddingLeft: theme.spacing(8),
  },
  itemText: {
    "& .MuiTypography-body1": {
      lineHeight: 1.45,
    },
  },
  eventContainer: {
    width: "100%",
  },
  dateLabel: {
    marginBottom: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.87);",
  },
}));

export default useStyles;
